import React, { useContext } from "react";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AuthProvider, AuthContext } from "./context/AuthContext";
import { useHeartbeat } from './hooks/useHeartbeat';

import Login from "./pages/login/Login";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import PainelPage from "./pages/painel/Painel";
import PlanosPage from "./pages/planos/PlanosPage";
import MensagensPage from "./pages/mensagens/MensagensPage";

function App() {
  return (
    <AuthProvider>         {/* ← AuthProvider primeiro */}
      <BrowserRouter>
        <Layout />
      </BrowserRouter>
    </AuthProvider>
  );
}

const Layout = () => {
  const { user } = useContext(AuthContext);
  useHeartbeat(); // ← aqui dentro, onde o contexto já existe

  return (
    <>
      {user && <Header />}
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<RequireSuperAdmin />}>
          <Route path="/painel" element={<PainelPage />} />
          <Route path="/planos" element={<PlanosPage />} />
          <Route path="/mensagens" element={<MensagensPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
      <Footer />
    </>
  );
};

const RequireSuperAdmin = () => {
  const { user } = useContext(AuthContext);
  if (!user) return <Navigate to="/login" replace />;
  if (user.nivel_acesso !== "superadmin") return <Navigate to="/login" replace />;
  return <Outlet />;
};

export default App;